import {
  createContext,
  useContext,
  useMemo,
} from "react";
import {
  DEFAULT_TENANT_INDUSTRY,
  getIndustryLabels,
  normalizeTenantIndustry,
} from "../utils/industryLabels";

const IndustryContext = createContext({
  industry: DEFAULT_TENANT_INDUSTRY,
  labels: getIndustryLabels(DEFAULT_TENANT_INDUSTRY),
});

export function IndustryProvider({ industry, children }) {
  const value = useMemo(() => {
    const normalized = normalizeTenantIndustry(industry);
    return {
      industry: normalized,
      labels: getIndustryLabels(normalized),
    };
  }, [industry]);

  return (
    <IndustryContext.Provider value={value}>{children}</IndustryContext.Provider>
  );
}

export function useIndustry() {
  return useContext(IndustryContext);
}

export function useIndustryLabels() {
  return useIndustry().labels;
}
